import React, { useEffect, useState } from 'react';
import {
  Button,
  Modal,
  Box,
  TextField,
  Select,
  MenuItem,
  Typography,
  FormControl,
  InputLabel,
  Grid,
  Pagination,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import requestStore from '../../stores/requestStore';
import SaleTypeSelectorRequest from '../object/SaleTypeSelectorRequest';
import CategorySelectorRequest from '../object/CategorySelectorRequest';

import ExtraFilters from '../object/ExtraFilters';
import filterStore from '../../stores/filterStore';
import { toJS } from 'mobx';

import { observer } from 'mobx-react-lite';
import ObjectCardRu from '../object/ObjectCardRu';
import objectStore from '../../stores/objectStore';
import i18nStore from '../../stores/i18nStore';
import ObjectCardDefault from '../object/ObjectCardDefault';
import ListObjectRequest from '../object/ListObjectRequest';

import statusStore from '../../stores/statusStore';
import AddressRequest from '../object/AddressRequest';
import logger from '../../utils/logger';
import ObjectSourceRequestPage from '../ObjectSourceRequestPage';
import CloseIcon from '@mui/icons-material/Close';
import { FaRegSave } from 'react-icons/fa';
import { IoSearch } from 'react-icons/io5';
import './styles.css'; // Импорт стилей для анимации иконок
import requestSourceStore from '../../stores/requestSourceStore';
import organizationSessionStore from '../../stores/organizationSessionStore';
import ClientPicker from '../client/ClientPicker';
import { resolveContextualCreateTarget } from '../../utils/kanbanCreation';

// компонент для добавления новой заявки

const AddNewRequest = observer(({ onSave, onCancel, boardId, targetColumnId = null }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [selectedColumn, setSelectedColumn] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [categoryParams, setCategoryParams] = useState(-1); // Храним id выбранной категории. -1 - Все
  const [subcategoryParams, setSubcategoryParams] = useState([]); // Храним id выбранных подкатегорий
  const [saleTypeParams, setSaleTypeParams] = useState('All'); // Храним тип сделки
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [validationMessage, setValidationMessage] = useState('Введите заголовок заявки');
  const [currentPage, setCurrentPage] = useState(1); // Состояние для текущей страницы
  const [selectedStatusId, setSelectedStatusId] = useState(null);
  const [addressShort, setAddressShort] = useState(''); // Добавляем состояние для короткого адреса
  const [sourceId, setSourceId] = useState('');
  const [clientMode, setClientMode] = useState('NONE');
  const [clientId, setClientId] = useState('');
  const [newClientName, setNewClientName] = useState('');
  const [newClientPhone, setNewClientPhone] = useState('');
  const [newClientEmail, setNewClientEmail] = useState('');

  const columns = requestStore.getBoardsByIdArray(boardId).filter(column => column.systemType === 'NORMAL');
  const contextualTargetColumnId = resolveContextualCreateTarget(columns, targetColumnId);
  const isContextualCreate = contextualTargetColumnId !== null;
  const [categotyForExtraFilter, setCategotyForExtraFilter] = useState();

  const handleCloseModal = () => setModalOpen(false);


  const handleOpenModal = () => {
    logger.log('🏀 ', requestStore.filterForRequest.selectedSubcategories[0]);

    setCategotyForExtraFilter(requestStore.filterForRequest.selectedSubcategories[0].id);
    // Теперь updateSelectedFields не сбрасывает существующие значения,
    // а только добавляет отсутствующие поля
    requestStore.updateSelectedFields();
    setModalOpen(true);
  };

  /* 	const saleTypeHandler = saleType => {
		setSaleTypeParams(saleType)
	} */

  // Устанавливаем начальное значение с sortOrder === 1 при монтировании
  useEffect(() => {
    requestSourceStore.fetchSources().catch(() => {});
    // Находим статус с sortOrder === 1 и устанавливаем его как начальное значение
    const defaultStatus = statusStore.statuses.find((status) => status.sortOrder === 1);
    if (defaultStatus) {
      requestStore.statusForNewRequest = defaultStatus.id;
    }
    // очистка подкатегорий при монтировании компонента. Убрать когда будет отдельный набор objectPageControls для заявок
    filterStore.clearFilters();

    // Очистка при размонтировании
    return () => {
      logger.log('AddNewRequest размонтируется, очищаем statusForNewRequest');
      requestStore.clearRequestStoreFilter();
      /* requestStore.statusForNewRequest = null // Очищаем значение */
      requestStore.suitedObjectForRequest = [];
      requestStore.notSuitedObjectForRequest = [];
    };
  }, []);

  const clientRequired = Boolean(organizationSessionStore.currentContext?.policies?.requireClientOnRequestCreation);
  useEffect(() => {
    if (clientRequired && clientMode === 'NONE') setClientMode('EXISTING');
  }, [clientRequired, clientMode]);

  const onSelectionChangeCategory = ({ category, subcategories }) => {
    logger.log(`функция onSelectionChangeCategory`);

    const plainCategory = category ? toJS(category) : -1;
    const plainSubcategories = subcategories.length
      ? subcategories.map((sub) => toJS(sub))
      : plainCategory
      ? plainCategory.subcategories.map((sub) => toJS(sub))
      : [];

    setCategoryParams(plainCategory ? { id: plainCategory.id } : -1);
    setSubcategoryParams(plainSubcategories.map((sub) => ({ id: sub.id })));

    logger.log('🎀 Category Selected:', plainCategory);
    logger.log('🎀 Subcategories Selected:', plainSubcategories);
  };

  useEffect(() => {
    if (isContextualCreate) {
      setSelectedColumn(contextualTargetColumnId);
      return;
    }
    if (columns.length > 0 && !columns.some(column => String(column.columnId) === String(selectedColumn))) {
      setSelectedColumn(columns[0].columnId);
    }
  }, [columns, contextualTargetColumnId, isContextualCreate, selectedColumn]);

  // Обработчик для получения значения адреса из AddressRequest
  const handleAddressChange = (address) => {
    setAddressShort(address);
    logger.log('Получен короткий адрес:', address);
  };

  function handleSave() {
    if (!title.trim()) {
      setValidationMessage('Введите заголовок заявки');
      setIsAlertOpen(true);
      return;
    }

    if (clientRequired && clientMode === 'NONE') {
      setValidationMessage('Укажите существующего клиента или создайте нового.');
      setIsAlertOpen(true);
      return;
    }
    if (clientMode === 'EXISTING' && !clientId) {
      setValidationMessage('Выберите клиента.');
      setIsAlertOpen(true);
      return;
    }
    if (clientMode === 'NEW' && !newClientName.trim()) {
      setValidationMessage('Укажите имя нового клиента.');
      setIsAlertOpen(true);
      return;
    }
    const columnId = contextualTargetColumnId || selectedColumn;
    logger.log('Saving request:');
    // Сохраняем заявку с коротким адресом
    const clientSelection = clientMode === 'EXISTING'
      ? { clientId }
      : clientMode === 'NEW'
        ? { newClient: { name: newClientName.trim(), phone: newClientPhone.trim() || null, email: newClientEmail.trim() || null } }
        : null;
    onSave(boardId, columnId, title, description, addressShort, sourceId || null, clientSelection);
  }

  function getFilteredObjectsForRequest() {
    filterStore.fetchFOfromNewRequest(currentPage);
  }

  // Обработчик изменения страницы
  const handlePageChange = (event, page) => {
    setCurrentPage(page);
    filterStore.fetchFOfromNewRequest(page);
  };

  // Очистка дополнительных фильтров
  const clearExtraFilter = () => {
    requestStore.clearRequestStoreFilter();
    getFilteredObjectsForRequest(); // Обновляем объекты после очистки фильтра
  };

  const locale = i18nStore.currentCountry;

  // Проверяем, есть ли данные в extraFilter
  const hasExtraFilter = Object.keys(requestStore.extraFilter).length > 0;

  return (
    <Box
      display=""
      sx={{
        width: '100%',
        maxWidth: '100%',
        padding: isMobile ? '8px' : '16px',
      }}>
      {import.meta.env.VITE_SHOW_COMPONENT_NAME === 'true' && (
        <div onClick={() => logger.log('AddNewRequest Render')}>% AddNewRequest %</div>
      )}
      <div className="text-xl font-bold">Новая заявка</div>
      <div
        className={`flex justify-end gap-${
          isMobile ? '3' : '5'
        } mt-2 mb-2 items-center align-baseline`}>
        <FaRegSave
          onClick={handleSave}
          className="cursor-pointer mr-5 icon-hover"
          title="Сохранить заявку"
          size={isMobile ? 20 : 24}
        />
        <CloseIcon
          onClick={onCancel}
          className="cursor-pointer icon-hover"
          title="Отменить"
          fontSize={isMobile ? 'medium' : 'large'}
        />
      </div>

      {!isContextualCreate && <Select
        value={selectedColumn || ''}
        onChange={(e) => setSelectedColumn(e.target.value)}
        fullWidth
        size={isMobile ? 'small' : 'medium'}
        sx={{ mb: 2 }}>
        {columns.map((column) => (
          <MenuItem key={column.columnId} value={column.columnId}>
            {column.name}
          </MenuItem>
        ))}
      </Select>}
      <FormControl fullWidth size={isMobile ? 'small' : 'medium'} sx={{ mb: 2 }}>
        <InputLabel id="request-source-label">Источник</InputLabel>
        <Select
          labelId="request-source-label"
          label="Источник"
          value={sourceId}
          onChange={(event) => setSourceId(event.target.value)}>
          <MenuItem value=""><em>Не указан</em></MenuItem>
          {requestSourceStore.sources.map(source => (
            <MenuItem key={source.id} value={source.id}>{source.name}</MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl fullWidth size={isMobile ? 'small' : 'medium'} sx={{ mb: 2 }}>
        <InputLabel id="request-client-label">Клиент</InputLabel>
        <Select
          labelId="request-client-label"
          label="Клиент"
          value={clientMode}
          onChange={(event) => setClientMode(event.target.value)}>
          {!clientRequired && <MenuItem value="NONE"><em>Не указан</em></MenuItem>}
          <MenuItem value="EXISTING">Выбрать существующего</MenuItem>
          <MenuItem value="NEW">Создать нового</MenuItem>
        </Select>
      </FormControl>
      {clientMode === 'EXISTING' && <Box sx={{ mb: 2 }}><ClientPicker value={clientId} onChange={setClientId} label="Существующий клиент" /></Box>}
      {clientMode === 'NEW' && <Box sx={{ mb: 2 }}>
        <TextField label="Имя клиента" value={newClientName} onChange={(event) => setNewClientName(event.target.value)} fullWidth required sx={{ mb: 1 }} />
        <TextField label="Телефон клиента" value={newClientPhone} onChange={(event) => setNewClientPhone(event.target.value)} fullWidth sx={{ mb: 1 }} />
        <TextField label="Электронная почта клиента" value={newClientEmail} onChange={(event) => setNewClientEmail(event.target.value)} fullWidth />
      </Box>}
      <TextField
        label="Заголовок"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        fullWidth
        size={isMobile ? 'small' : 'medium'}
        sx={{ mb: 2 }}
      />
      <TextField
        label="Описание заявки"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        multiline
        rows={isMobile ? 3 : 4}
        fullWidth
        size={isMobile ? 'small' : 'medium'}
        sx={{ mb: 2 }}
      />
      <SaleTypeSelectorRequest />
      <div className="mt-3">
        <CategorySelectorRequest onSelectionChange={onSelectionChangeCategory} />
      </div>

      <ObjectSourceRequestPage />

      <div className="">
        <div className="mb-4">
          {requestStore.filterForRequest.selectedSubcategories.length === 1 && (
            <Button
              onClick={handleOpenModal}
              variant="outlined"
              color="primary"
              size={isMobile ? 'small' : 'medium'}>
              Расширенный фильтр
            </Button>
          )}

          {hasExtraFilter && (
            <Button
              onClick={clearExtraFilter}
              variant="outlined"
              color="secondary"
              size={isMobile ? 'small' : 'medium'}
              sx={{ marginLeft: '10px' }}>
              Сбросить фильтр
            </Button>
          )}
        </div>

        <AddressRequest onAddressChange={handleAddressChange} />

        <Modal open={isModalOpen} onClose={handleCloseModal} fullScreen={isMobile}>
          <Box
            sx={(theme) => ({
              position: 'absolute',
              top: isMobile ? 0 : '2%',
              left: isMobile ? 0 : '50%',
              transform: isMobile ? 'none' : 'translate(-50%, 0)',
              width: isMobile ? '100%' : '97%',
              height: isMobile ? '100%' : 'auto',
              bgcolor: 'background.paper',
              boxShadow: 24,
              p: isMobile ? 1 : 2,
              borderRadius: isMobile ? 0 : 1,
              maxHeight: isMobile ? '100vh' : '96vh',
              overflowY: 'hidden',

              // Адаптивные размеры для разных экранов
              [theme.breakpoints.up('sm')]: {
                width: '80%',
              },
              [theme.breakpoints.up('md')]: {
                width: '70%',
              },
              [theme.breakpoints.up('lg')]: {
                width: '60%',
              },
              [theme.breakpoints.up('xl')]: {
                width: '50%',
              },
            })}>
            {/* Доп поля рендерятся только если выбрана категория */}
            {categotyForExtraFilter && (
              <ExtraFilters
                categoryId={categotyForExtraFilter}
                source={'request'}
                onClose={handleCloseModal}
              />
            )}
          </Box>
        </Modal>
        <Modal open={isAlertOpen} onClose={() => setIsAlertOpen(false)}>
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: isMobile ? '90%' : 300,
              bgcolor: 'background.paper',
              boxShadow: 24,
              p: 2,
              textAlign: 'center',
              borderRadius: 1,
            }}>
            <Typography variant="body1">{validationMessage}</Typography>
            <Button onClick={() => setIsAlertOpen(false)} variant="contained" sx={{ mt: 2 }}>
              Ок
            </Button>
          </Box>
        </Modal>
      </div>
      <Box className="mt-4">
        <Button
          color="secondary"
          variant="outlined"
          onClick={getFilteredObjectsForRequest}
          size={isMobile ? 'small' : 'medium'}
          fullWidth={isMobile}>
          Подобрать объекты <IoSearch className="ml-2" />
        </Button>
      </Box>
      <div className="container mx-auto py-3">
        <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 gap-4"></div>
      </div>
      {objectStore.totalPagesRequest > 1 && (
        <Box display="flex" justifyContent="center" mt={2} mb={2}>
          <Pagination
            count={objectStore.totalPagesRequest}
            page={currentPage}
            onChange={handlePageChange}
            color="primary"
            showFirstButton
            showLastButton
            siblingCount={isMobile ? 0 : 1}
            boundaryCount={1}
            size={isMobile ? 'small' : 'medium'}
          />
        </Box>
      )}
      <ListObjectRequest objects={objectStore.objectsForRequest} />

      {objectStore.totalPagesRequest > 1 && (
        <Box display="flex" justifyContent="center" mt={2} mb={2}>
          <Pagination
            count={objectStore.totalPagesRequest}
            page={currentPage}
            onChange={handlePageChange}
            color="primary"
            showFirstButton
            showLastButton
            siblingCount={isMobile ? 0 : 1}
            boundaryCount={1}
            size={isMobile ? 'small' : 'medium'}
          />
        </Box>
      )}

      <Box
        display="flex"
        justifyContent={isMobile ? 'center' : 'flex-end'}
        gap={isMobile ? 1 : 2}
        mt={2}
        sx={{
          marginBottom: '80px',
          flexDirection: isMobile ? 'column' : 'row',
        }}>
        <Button
          variant="outlined"
          onClick={onCancel}
          fullWidth={isMobile}
          size={isMobile ? 'small' : 'medium'}>
          Отмена
        </Button>
        <Button
          variant="contained"
          onClick={handleSave}
          fullWidth={isMobile}
          size={isMobile ? 'small' : 'medium'}>
          Сохранить заявку
        </Button>
      </Box>
    </Box>
  );
});
export default AddNewRequest;
